import React, { FC } from 'react';
import { compose } from 'recompose';
import { Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import Linkify from 'react-linkify';

import { IWithContent, withContent } from 'providers';
import { isTextOnly } from '../helpers';

interface IPropsEnhanced extends IWithContent, WithStyles<typeof styles> {}

const LARGE_TEXT_CUTOFF = 80;

const styles = (theme: Theme) =>
  createStyles({
    root: {
      fontWeight: theme.typography.fontWeightRegular,
      whiteSpace: 'pre-line',
      ...theme.mixins.breakWord,
      '& a': {
        textDecoration: 'none',
        color: theme.palette.primary.main,
      },
    },
  });

const enhancers = compose<IPropsEnhanced, {}>(withContent, withStyles(styles));

const Body: FC<IPropsEnhanced> = ({ classes, content }) => {
  const { content_object } = content;
  const { body } = content_object;

  if (!body) {
    return null;
  }

  const textOnly = isTextOnly(content);
  const isLargeText = textOnly && body.length < LARGE_TEXT_CUTOFF;
  const variant = isLargeText ? 'h6' : 'subtitle2';

  return (
    <Typography className={classes.root} variant={variant}>
      <Linkify properties={{ target: '_blank' }}>{body}</Linkify>
    </Typography>
  );
};

export default enhancers(Body);
